import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import * as Sentry from "@sentry/react";
import { setUser, setAccessToken, setEmail } from "../../store/authSlice";
import AuthGeneralInput from "../../components/input/authinput";
import { AppButton } from "../../components/buttons/button";
import { H1Title, Paragraph } from "../../components/typography/typography";
import AuthService from "../../services/authService";
import { Error as ToastError } from "../../components/toast/toast";
import _route from "../../constants/routes";

export default function Login() {
  const [form, setForm] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: '' });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await AuthService.login(form);
      if (!data.data.emailVerified) {
        dispatch(setEmail(form.email));
        navigate(_route._verify);
      } else {
        dispatch(setUser(data.data.user));
        dispatch(setAccessToken(data.data.accessToken));
        Sentry.setUser({ id: data.data.user._id, email: data.data.user.email, role: data.data.user.role });
        const role = data.data.user.role;
        if (role === 'admin') navigate('/admin/dashboard');
        else if (role === 'judge') navigate('/judge/dashboard');
        else navigate('/dashboard');
      }
    } catch (err) {
      const msg = err.response?.data?.error?.message || 'Login failed';
      ToastError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="w-full space-y-5">
      <div>
        <H1Title size="sm">Welcome Back</H1Title>
        <Paragraph size="base" className="text-grey-667 mt-1">
          Sign in to your Human Development Lab account
        </Paragraph>
      </div>

      <AuthGeneralInput
        label="Email"
        type="email"
        name="email"
        placeholder="Enter your email"
        value={form.email}
        change={handleChange}
        error={errors.email}
      />

      <AuthGeneralInput
        label="Password"
        type="password"
        name="password"
        placeholder="Enter your password"
        value={form.password}
        change={handleChange}
        error={errors.password}
      />

      <div className="flex justify-end">
        <Link to={_route._forgot_password} className="text-sm text-primary hover:underline">
          Forgot password?
        </Link>
      </div>

      <AppButton type="submit" loading={loading}>
        Sign In
      </AppButton>

      <p className="text-sm text-center text-grey-667">
        Don't have an account?{' '}
        <Link to={_route._signup} className="text-primary font-semibold hover:underline">
          Sign Up
        </Link>
      </p>
    </form>
  );
}
